import { render, staticRenderFns } from "./Package.vue?vue&type=template&id=5eda8fc6&scoped=true"
import script from "./Package.vue?vue&type=script&lang=js"
export * from "./Package.vue?vue&type=script&lang=js"
import style0 from "./Package.vue?vue&type=style&index=0&id=5eda8fc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eda8fc6",
  null
  
)

export default component.exports